//@flow
import withHandledGroupFinTermData from "./withHandledGroupFinTermData";
import GroupFinTermCard from "./GroupFinTermCard";

const ConnectedGroupFinTermCard = withHandledGroupFinTermData(GroupFinTermCard);

export default ConnectedGroupFinTermCard;